export function clamp(val, min, max) {
	if (val < min) {
		return min
	}
	if (val > max) {
		return max
	}
	return val
}

export function roundNumber(num, scale) {
	if (!('' + num).includes('e')) {
		return +(Math.round(num + 'e+' + scale) + 'e-' + scale);
	} else {
		const arr = ('' + num).split('e');
		let sig = ''
		if (+arr[1] + scale > 0) {
			sig = '+';
		}
		return +(Math.round(+arr[0] + 'e' + sig + (+arr[1] + scale)) + 'e-' + scale);
	}
}

export const spaceAndRoundNumber = amount => {
	const [intPart, decPart] = amount.toFixed(2).split('.');
	return intPart.length > 3
			? `${intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}${decPart === '00' ? '' : '.' + decPart}`
			: amount.toFixed(2);
};
